import { Component, Inject } from '@angular/core'
import { ResizeHandleState } from '@helios/generic-components'
import { BasePanelComponent, LayoutContainer } from '@helios/panel-base'
import {
  JobsPayload,
  RootState,
  clearFocusedJobs,
  selectActiveSession,
  selectFocusedAccounts,
  selectFocusedJobs,
} from '@helios/state-management'
import { Store } from '@ngrx/store'
import { ComponentContainer } from 'golden-layout'
import { of } from 'rxjs'
import {
  debounceTime,
  distinctUntilChanged,
  filter,
  map,
  mergeAll,
  tap,
} from 'rxjs/operators'
import { JobsKey } from '../panel-key'

interface JobsPanelState {
  resizeHandleState: ResizeHandleState
}

@Component({
  selector: 'hs-jobs',
  templateUrl: './jobs-panel.component.html',
  styleUrls: ['./jobs-panel.component.scss'],
})
export class JobsPanelComponent extends BasePanelComponent<JobsPanelState> {
  panelKey = JobsKey
  activeTabIndex = 1 // 1 means first tab i.e. commands tab
  selectedJobs: JobsPayload | undefined
  selectedCommandsJobIds?: string
  focusedIds$ = of(
    this.store
      .select(selectActiveSession)
      .pipe(map(session => session?.loadedAccountIds ?? [])),
    this.store.select(selectFocusedAccounts).pipe(debounceTime(500)),
    this.store.select(selectFocusedJobs).pipe(
      distinctUntilChanged((a, b) => a?.jobIds === b?.jobIds),
      tap(jobs => {
        this.selectedJobs = jobs
      }),
      map(jobs => (jobs ? jobs.accountIds : [])),
      filter(jobs => jobs && jobs.length > 0),
    ),
  )
    .pipe(mergeAll())
    .pipe(
      tap(() => {
        // reset selectedJobIds whenever account is selected/loaded/focused
        this.selectedJobIds = this.selectedJobs ? this.selectedJobs.jobIds : []
        // open Exception panel for failed job only
        this.activeTabIndex = this.selectedJobs ? 2 : 1
      }),
      filter(arr => arr && !!arr.length),
    )

  selectedJobIds: number[] = []

  constructor(
    @Inject(LayoutContainer) container: ComponentContainer,
    private readonly store: Store<RootState>,
  ) {
    super(container)
  }

  onClearSelectedJob() {
    this.store.dispatch(clearFocusedJobs())
  }

  setSelectedCommandsJobIds(jobIds: string) {
    this.selectedCommandsJobIds = jobIds
  }

  onResizeFinished(resizeHandleState: ResizeHandleState) {
    this.setState({
      ...this.state,
      resizeHandleState,
    })
  }
}
